import React from 'react'
import { StyledTableContainer, StyledRowContainer } from 'assets/styles/global'
import Icon from 'components/UI/Icons'

const TransactionHistory = ({ open }: { open: any }) => {
    return (
        <StyledTableContainer>
            <StyledRowContainer status='0' onClick={open}>
                <div className='hero'>
                    <Icon name='ring' className='w-8'  />
                    <div className='ml-3'>
                        <p className='title'>Amount</p>
                        <p className='detail'>N5,000</p>
                    </div>
                </div>
                <div>
                    <p className='title'>Type</p>
                    <p className='detail'>Account deposit</p>
                </div>
                <div>
                    <p className='title'>Status</p>
                    <p className='detail status'>Pending</p>
                </div>
                <div className='last'>
                    <p className='title'>Date created</p>
                    <p className='detail'>12 - 06 - 2020</p>
                </div>
                <div>
                    <button className='btn'>View</button>
                </div>
            </StyledRowContainer>
        </StyledTableContainer>
    )
}

export default TransactionHistory
